import { createGlobalStyle } from 'styled-components';

import AbrilFatfaceRegularTTF from './assets/fonts/AbrilFatface-Regular.ttf';
import AvenirNextCondensedDemiBoldTTF from './assets/fonts/Avenir-Next-Condensed-Demi-Bold.ttf';
import { InterRegularTTF, InterMediumTTF, InterBoldTTF } from './assets/fonts/Inter.ttf';
import RobotoBoldTTF from './assets/fonts/Roboto-Bold.ttf';


const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    height: 100%;
    font-family: Inter, sans-serif;
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    src: url(${InterRegularTTF}) format('truetype');
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    src: url(${InterMediumTTF}) format('truetype');
  }

  @font-face {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 700;
    src: url(${InterBoldTTF}) format('truetype');
  }

  @font-face {
    font-family: 'Abril Fatface';
    font-style: normal;
    font-weight: 400;
    src: url(${AbrilFatfaceRegularTTF}) format('truetype');
  }

  @font-face {
    font-family: 'Avenir Next Condensed';
    font-style: normal;
    font-weight: 600;
    src: url(${AvenirNextCondensedDemiBoldTTF}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto Bold';
    font-style: normal;
    font-weight: 600;
    src: url(${RobotoBoldTTF}) format('truetype');
  }
`;

export { GlobalStyle };
